import React, { useEffect, useState } from "react";
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import { 
    Nav,
    NavbarContainer, 
    MobileIcon,
    NavMenu, 
    NavLinks,
    NavLogo,
    NavItem
} from "./NavbarElements"
const Navbar = ( {toggle} ) => {
    const [ scrollNav, setScrollNav ] = useState(false);
    const changeNav = () => {
        if(window.scrollY >= 80){
            setScrollNav(true)
        } else{
            setScrollNav(false);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', changeNav);
    }, [])

    const toggleHome = () => {
        scroll.scrollToTop();
    }
    return(
        <>
        <IconContext.Provider value = {{color : '#fff'}}>
        <Nav scrollNav = {scrollNav}>
            <NavbarContainer>
                <NavLogo onClick = {toggleHome}  to = "/">Kiran R Nair</NavLogo>
                <MobileIcon onClick = {toggle}>
                    <FaBars />
                </MobileIcon>
                <NavMenu>
                <NavItem>
                        <NavLinks to = 'home'
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}
                        activeClass = "active"
                        >About</NavLinks>
                </NavItem>
                    
                    <NavItem>
                        <NavLinks to = 'about'
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}
                        activeClass = "active"
                        >Skills</NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks to = 'services'
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}
                        activeClass = "active"
                        >Projects</NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks to = 'contact'
                        smooth = {true}
                        duration = {500}
                        spy = {true}
                        exact = 'true'
                        offset = {-80}
                        activeClass = "active"
                        >Contact</NavLinks>
                    </NavItem>
                </NavMenu>
            </NavbarContainer>
        </Nav>
        </IconContext.Provider>
        </>
    )
}
export default Navbar;
